import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import {
  Link,
  NavLink,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import styled, { css } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { UserOutlined } from "@ant-design/icons";
import { SettingOutlined } from "@ant-design/icons";

const backgroundStyle = {
  background: "#00297A",
  color: "#FFFFFF",
};
const navbarContainerStyle = {
  margin: "0 6vw",
  padding: "0",
  width: "100vw",
  display: "flex",
  justifyContent: "space-between",
};
const backgroundContainerStyle = {
  background: "#00297A",
  color: "#FFFFFF",
  display: "flex",
  alignItems: "stretch",
  flexWrap: "nowrap",
  textAlign: "center",
};

const backgroundActiveSyle = {
  background: "#00297A",
  color: "#FFFFFF",
  fontWeight: 700,
  width: "auto",
  borderBottomStyle: "solid",
  borderBottomColor: "#FFFFFF",
  textAlign: "center",
};

const PortraitView = styled.nav`
  background: #00297a;
  color: #ffffff;
  position: fixed;
  bottom: 0px;
  width: 100%;
  margin: 0px;
  display: flex;
  align-items: stretch;
  flex-wrap: nowrap;
  z-index: 999;

  @media only screen and (orientation: landscape) {
    position: sticky;
  }
`;
const NavbarView = styled.nav`
  background: #00297a;
  color: #ffffff;
  width: 100%;
  margin: 0px;
  display: flex;
  align-items: stretch;
  flex-wrap: nowrap;
  z-index: 999;

  @media only screen and (orientation: landscape) {
    position: sticky;
  }
`;
const NavbarRedux = ({ isPortrait, userData, pluginSubscriptions }) => {
  const navigate = useNavigate();
  const [mobileView, setMobileView] = useState(false);
  const { t } = useTranslation();

  const handleProSettings = () => {
    navigate("/profile", {});
  };
  const handlePlugins = () => {
    navigate("/profile?section=plugins", {});
  };
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      {isPortrait ? (
        <>
          <PortraitView className="navbar navbar-expand-sm ">
            <div className="container">
              <NavLink
                className={({ isActive }) =>
                  "nav-item nav-link" + (isActive ? " active" : "")
                }
                style={({ isActive }) =>
                  isActive ? backgroundActiveSyle : backgroundStyle
                }
                to="/bowlers"
              >
                {t("general.bowlers")}
              </NavLink>

              <NavLink
                className={({ isActive }) =>
                  "nav-item nav-link" + (isActive ? " active" : "")
                }
                style={({ isActive }) =>
                  isActive ? backgroundActiveSyle : backgroundStyle
                }
                to="/dashboard"
              >
                <div style={{ textAlign: "center" }}>
                  {t("general.dashboard")}
                </div>
              </NavLink>
              {pluginSubscriptions.indexOf("JOB_BOARD") >= 0 && (
                <NavLink
                  className={({ isActive }) =>
                    "nav-item nav-link" + (isActive ? " active" : "")
                  }
                  style={({ isActive }) =>
                    isActive ? backgroundActiveSyle : backgroundStyle
                  }
                  to="/job_board"
                >
                  <div style={{ textAlign: "center" }}>
                    {t("jobBoard.job_board_menu")}
                  </div>
                </NavLink>
              )}

              <NavLink
                className={({ isActive }) =>
                  "nav-item nav-link" + (isActive ? " active" : "")
                }
                style={({ isActive }) =>
                  isActive ? backgroundActiveSyle : backgroundStyle
                }
                to="/settings"
              >
                {/* {t("general.settings")} */}
                <SettingOutlined style={{ fontSize: "24px" }} />
              </NavLink>

              <NavLink
                className="nav-item nav-link btn"
                style={({ isActive }) =>
                  isActive ? backgroundActiveSyle : backgroundStyle
                }
                to="/profile"
              >
                <UserOutlined style={{ fontSize: "24px" }} />
              </NavLink>
            </div>
          </PortraitView>
        </>
      ) : (
        // <nav className="navbar navbar-expand-sm " style={backgroundStyle}>
        <NavbarView className="navbar navbar-expand-sm ">
          <div style={navbarContainerStyle}>
            <div style={backgroundContainerStyle}>
              <button
                className="nav-item nav-link btn"
                style={backgroundStyle}
                onClick={handleBack}
              >
                <FontAwesomeIcon icon={["fas", "arrow-left"]} />
              </button>

              <NavLink
                className={({ isActive }) =>
                  "nav-item nav-link" + (isActive ? " active" : "")
                }
                style={({ isActive }) =>
                  isActive ? backgroundActiveSyle : backgroundStyle
                }
                to="/bowlers"
              >
                {t("general.bowlers")}
              </NavLink>

              <NavLink
                className={({ isActive }) =>
                  "nav-item nav-link" + (isActive ? " active" : "")
                }
                style={({ isActive }) =>
                  isActive ? backgroundActiveSyle : backgroundStyle
                }
                to="/settings"
              >
                {t("general.settings")}
              </NavLink>

              <NavLink
                className={({ isActive }) =>
                  "nav-item nav-link" + (isActive ? " active" : "")
                }
                style={({ isActive }) =>
                  isActive ? backgroundActiveSyle : backgroundStyle
                }
                to="/dashboard"
              >
                {t("general.dashboard")}
              </NavLink>
              {pluginSubscriptions.indexOf("JOB_BOARD") >= 0 && (
                <NavLink
                  className={({ isActive }) =>
                    "nav-item nav-link" + (isActive ? " active" : "")
                  }
                  style={({ isActive }) =>
                    isActive ? backgroundActiveSyle : backgroundStyle
                  }
                  to="/job_board"
                >
                  {t("jobBoard.title")}
                </NavLink>
              )}
            </div>

            <div style={backgroundContainerStyle}>
              <button
                className="nav-item nav-link btn d-flex navbar-right"
                style={backgroundStyle}
                onClick={handleProSettings}
              >
                {userData.proshops[0].proshop.name !== "" &&
                !R.isNil(userData.proshops[0].proshop.name)
                  ? userData.proshops[0].proshop.name
                  : t("general.accountInfo")}
              </button>
              <button
                className="nav-item nav-link btn d-flex navbar-right"
                style={backgroundStyle}
                onClick={handleProSettings}
              >
                <UserOutlined />
              </button>
              {/* Junto al icono de perfil, como pidio Mark (#899). Desktop only:
                  portrait deja plugins donde ya estaba, dentro de Profile. */}
              <button
                className="nav-item nav-link btn d-flex justify-content-end navbar-right"
                style={backgroundStyle}
                onClick={handlePlugins}
                title={t("general.plugins")}
                aria-label={t("general.plugins")}
              >
                <FontAwesomeIcon icon={["fas", "plug"]} />
              </button>
            </div>
          </div>
        </NavbarView>
      )}
    </>
  );
};

export const Navbar = connect((state) => {
  return {
    userData: state.userSession.userData,
    pluginSubscriptions: state.plugin.pluginSubscriptions,
  };
}, {})(NavbarRedux);
